import React from 'react';
import { Form, Input, Select } from 'antd';
import { checkEmail, conditionCheckEmail } from 'util/validators';

const { Option } = Select;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  state = {
    editing: true,
  };

  componentDidUpdate(prevProps) {
    if (this.props.isReset !== prevProps.isReset) {
      this.form.resetFields();
    }
  }

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  save = (key, inputValue = '') => {
    const { record, handleSave, handleError } = this.props;
    const value = inputValue || this.form.getFieldValue(key);

    if (key === 'email') {
      if (!conditionCheckEmail(value)) {
        handleError(true);
        return;
      }
    }

    handleError(false);
    handleSave({ ...record, [key]: value });
  };

  renderCell = form => {
    this.form = form;
    const { children, dataIndex, record, title, roles, loadingRole } = this.props;
    const { editing } = this.state;
    let formItem = null;

    if (dataIndex === 'email') {
      formItem = <Form.Item style={{ margin: 0 }}>
      {form.getFieldDecorator(dataIndex, {
        initialValue: record[dataIndex],
        rules: [{ validator: checkEmail }],
      })(<Input style={{ width: 300 }} placeholder={title} onChange={e => this.save(dataIndex, e.target.value)} ref={node => (this.input = node)} />)}
    </Form.Item>
    }

    if (dataIndex === 'role') {
      formItem = <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(dataIndex, {
          initialValue: 'member',
        })(<Select ref={node => (this.input = node)} style={{ width: 300 }} onChange={e => this.save(dataIndex, e)}>
          <Option value="member">Member</Option>
          <Option value="line-manager">Line Manager</Option>
        </Select>)}
      </Form.Item>
    }

    if (dataIndex === 'line_manager' && form.getFieldValue('role') === 'member') {
      formItem = <Form.Item style={{ margin: 0 }}>
      {form.getFieldDecorator(dataIndex, {
        initialValue: [],
      })(<Select loading={loadingRole} placeholder='Chọn Line manager' ref={node => (this.input = node)} style={{ width: 300 }} onChange={e => this.save(dataIndex, e)}>
        {roles.map(role => <Option key={`role_${role.email}`} value={role.email}>{role.email}</Option>)}
      </Select>)}
    </Form.Item>
    }

    return editing ? (
      formItem
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24 }}
        onClick={this.toggleEdit}
      >
        {children}
      </div>
    );
  };

  render() {
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      children,
      roles,
      loadingRole,
      isReset,
      handleError,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  }
}

export {
  EditableFormRow,
  EditableCell,
}